import React, { ReactNode } from 'react';
import styles from '../styles/PtSubscriptionPlanSection.scss';
import { Chip } from 'drift-ui';
import { useTranslation } from 'react-i18next';

type SubscriptionPlanProps = {
  title?: string;
  status?: ReactNode;
  statusSubText?: string;
  showFreeTrialChip?: boolean;
  includesTitle?: string;
  includesSubtitle?: string;
  includesText?: string[];
  extraInfoTitle?: string;
  extraInfoText?: string;
  button?: ReactNode;
  icon?: ReactNode;
};

const PtSubscriptionPlanSection: React.FC<SubscriptionPlanProps> = ({
  title,
  status,
  statusSubText,
  showFreeTrialChip,
  includesTitle,
  includesSubtitle,
  includesText,
  extraInfoTitle,
  extraInfoText,
  button,
  icon,
}) => {
  const { t } = useTranslation('common', { keyPrefix: 'proTransportSubscriptions' });
  return (
    <div className={styles.section}>
      <div className={styles.topSection}>
        <div className={styles.title}>{title}</div>
        <div className={styles.statusContainer}>
          <div className={styles.status}>{status}</div>
          <div className={styles.iconWrapper}>{icon}</div>
        </div>
        {statusSubText && <div className={styles.statusSubText}>{statusSubText}</div>}
        {showFreeTrialChip && (
          <Chip className={styles.trialChip} color="success" label={t('free_trial')} variant="filled" size="small" />
        )}
      </div>
      <div className={styles.includesAndExtraContainer}>
        <div className={styles.includesTitle}>{includesTitle}</div>
        <div className={styles.includesSubtitle}>{includesSubtitle}</div>
        <div>
          {includesText?.map((text) => (
            <div key={text} className={styles.includesText}>
              {text}
            </div>
          ))}
        </div>
        <div className={styles.extraInfoTitle}>{extraInfoTitle}</div>
        <div className={styles.extraInfoText}>{extraInfoText}</div>
      </div>
      <div className={styles.buttonContainer}>{button}</div>
    </div>
  );
};

export default PtSubscriptionPlanSection;
